
export const environment = {
   production: true,
   ribbon: undefined,
   environment: 'production',
   buildTimestamp: 1791281592943,
   ssoUrl: 'https://auth.cirqus.de',
   commitHash: 'c1943886297ddf166cdda98ab722ceb7d477ad33',
};
